'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by lyj on 2016/5/16.
                    */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PageView = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(PageView, _Component);

  function PageView() {
    (0, _classCallCheck3.default)(this, PageView);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(PageView).apply(this, arguments));
  }

  (0, _createClass3.default)(PageView, [{
    key: 'render',
    value: function render() {
      var linkClassName = this.props.pageLinkClassName;
      var cssClassName = this.props.pageClassName;

      if (this.props.selected) {
        if (typeof cssClassName !== 'undefined') {
          cssClassName = cssClassName + ' ' + this.props.activeClassName;
        } else {
          cssClassName = this.props.activeClassName;
        }
      }

      return _react2.default.createElement(
        'li',
        { className: cssClassName },
        _react2.default.createElement(
          'a',
          (0, _extends3.default)({}, this.props, { className: linkClassName }),
          this.props.page
        )
      );
    }
  }]);
  return PageView;
}(_react.Component), _class.propTypes = {
  pageLinkClassName: _react.PropTypes.string,
  pageClassName: _react.PropTypes.string,
  page: _react.PropTypes.number.isRequired,
  activeClassName: _react.PropTypes.string.isRequired,
  selected: _react.PropTypes.bool.isRequired
}, _temp);
exports.default = PageView;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Paginate/PageView.js
 ** module id = 1389
 ** module chunks = 0
 **/